__turbopack_context__.v({
  "indicatorDesktop": "TabButton-module-scss-module__GXTbxG__indicatorDesktop",
  "indicatorMobile": "TabButton-module-scss-module__GXTbxG__indicatorMobile",
  "inner": "TabButton-module-scss-module__GXTbxG__inner",
  "label": "TabButton-module-scss-module__GXTbxG__label",
  "tabButton": "TabButton-module-scss-module__GXTbxG__tabButton",
});
